import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../components/commons/CustomBtn";
import Container from "../../components/Container/Container";
import Programmes from "./views/programmes/Programmes";
import Stock from "./views/stock/Stock";
import Lot from "./views/lot/Lot";
import {
  setActiveOnglet,
  fetchProgrammes,
  fetchSingleProgram,
  removeOpenLot,
  removeOpenProgram,
  closeSearch,
} from "../../redux/actions/immobilierActions";
import DeepSearchResults from "./views/deepSearchResult/DeepSearchResult";

const Immobilier = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const {
    programmes,
    loading,
    error,
    pagination,
    activeOnglet,
    activeView,
    singleProgramId,
    singleProgram,
    openPrograms,
    openProgramsData,
    openLots,
    openLotsData,
    deepSearch,
  } = useSelector((state) => state.immobilierReducer);

  useEffect(() => {
    if (singleProgramId) {
      dispatch(fetchSingleProgram(singleProgramId));
    }
  }, [dispatch, singleProgramId]);

  useEffect(() => {
    dispatch(fetchProgrammes(currentPage, 25));
  }, [dispatch, currentPage]);

  const onlgetSetter = (onglet) => {
    dispatch(setActiveOnglet(onglet));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleCloseLot = (documentId) => {
    if (activeOnglet === `lot-${documentId}`) {
      dispatch(setActiveOnglet("stock"));
    }
    dispatch(removeOpenLot(documentId));
  };

  const handleCloseProgram = (documentId) => {
    if (activeOnglet === `programme-${documentId}`) {
      dispatch(setActiveOnglet("stock"));
    }
    dispatch(removeOpenProgram(documentId));
  };
  const handleSearchClose = () => {
    onlgetSetter("stock");
    dispatch(closeSearch());
  };
  const [displayedLot, setDisplayedLot] = useState(null);
  return (
    <Container>
      <div className="d-flex gap14">
        <CustomButton
          onClick={() => onlgetSetter("stock")}
          label="Stock"
          contentType1="Lots"
          contentLength1={pagination.total}
          contentLength2={pagination.total}
          contentType2="Programmes"
          contentLengthClass={`${
            activeOnglet === "stock"
              ? "regular fs11 pink "
              : "regular fs11 white"
          } `}
          buttonClass={`${
            activeOnglet === "stock"
              ? "bg-white radiusTop5 px-20 py-10 "
              : "bg-pink radiusTop5 px-20 py-10 white"
          } `}
          labelClass={`${
            activeOnglet === "stock"
              ? "pink fs16 semibold text-capitalize text-start"
              : "white fs16 semibold text-capitalize text-start"
          }`}
        />

        {deepSearch.length > 0 && (
          <div className="position-relative">
            <button
              className="position-absolute close-button"
              onClick={handleSearchClose}
            >
              ×
            </button>
            <CustomButton
              onClick={() => onlgetSetter("searchResults")}
              label="Résultats de recherche"
              contentType1="résultats"
              contentLength1={deepSearch.length}
              contentLengthClass={`${
                activeOnglet === "searchResults"
                  ? "regular fs11 pink "
                  : "regular fs11 white"
              } `}
              buttonClass={`${
                activeOnglet === "searchResults"
                  ? "bg-white radiusTop5 px-20 py-10 "
                  : "bg-pink radiusTop5 px-20 py-10 white"
              } `}
              labelClass={`${
                activeOnglet === "searchResults"
                  ? "pink fs16 semibold text-capitalize text-start"
                  : "white fs16 semibold text-capitalize text-start"
              }`}
            />
          </div>
        )}
        {openPrograms.map((programId) => (
          <div
            key={programId}
            className="d-flex align-items-center position-relative"
          >
            <CustomButton
              onClick={() => onlgetSetter(`programme-${programId}`)}
              label={
                programmes.find((p) => p.documentId === programId)?.name ? (
                  `Programme ${
                    programmes.find((p) => p.documentId === programId)?.name
                  }`
                ) : (
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )
              }
              disabled={
                !programmes.find((p) => p.documentId === programId)?.name
              }
              buttonClass={`${
                activeOnglet === `programme-${programId}`
                  ? "bg-white radiusTop5 px-20 py-10 pink h-100"
                  : "bg-pink radiusTop5 px-20 py-10 white h-100"
              } `}
              labelClass="fs16 semibold text-capitalize text-start"
            />

            <button
              onClick={(e) => {
                handleCloseProgram(programId);
              }}
              className="close-button"
            >
              ×
            </button>
          </div>
        ))}
        {openLots.map((lotId) => (
          <div
            key={lotId}
            className="d-flex align-items-center position-relative"
          >
            <CustomButton
              onClick={() => onlgetSetter(`lot-${lotId}`)}
              label={
                openLotsData[lotId]?.reference ? (
                  `Lot ${openLotsData[lotId]?.reference}`
                ) : (
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )
              }
              disabled={openLotsData[lotId]?.reference ? false : true}
              buttonClass={`${
                activeOnglet === `lot-${lotId}`
                  ? "bg-white radiusTop5 px-20 py-10 pink h-100"
                  : "bg-pink radiusTop5 px-20 py-10 white h-100"
              } `}
              labelClass="fs16 semibold text-capitalize text-start"
            />

            <button
              onClick={(e) => {
                handleCloseLot(lotId);
              }}
              className="close-button"
            >
              ×
            </button>
          </div>
        ))}
      </div>

      {activeOnglet === "stock" && (
        <Stock
          listeDesProgrammes={programmes}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          pagination={pagination}
        />
      )}
      {activeOnglet === "searchResults" && (
        <DeepSearchResults deepSearchResults={deepSearch} />
      )}
      {openPrograms.map(
        (programId) =>
          activeOnglet === `programme-${programId}` && (
            <Programmes
              key={programId}
              programmeId={programId}
              displayedLot={displayedLot}
              setDisplayedLot={setDisplayedLot}
            />
          )
      )}
      {openLots.map(
        (lotId) =>
          activeOnglet === `lot-${lotId}` && (
            <Lot
              key={lotId}
              lotId={lotId}
              lotData={openLotsData[lotId]}
              setDisplayedLot={setDisplayedLot}
            />
          )
      )}
    </Container>
  );
};

export default Immobilier;
